// @ts-check
import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import api from 'utils/api';
import { change, formValueSelector } from 'utils/reduxFormWrapper';
import Modal from 'shared/components/Modal';
import { ProviderSelectionInput } from 'shared/containers/portal_layout/HForm';
import { CreateProviderForm } from './CreateProviderForm';
import { decamelizeKeys } from 'humps';

const fetchOptions = _.debounce((input, setOptions) => {
  api
    .get('/agent_portal/api/providers', { params: { search_term: input } })
    .then(response => setOptions(null, { options: response.data.providers }));
  return null;
}, 350);

const CreatedProvider = ({ provider, clearProvider }) => {
  return (
    <div className="level">
      <div className="level-left">
        <div className="level-item" style={{ fontSize: '1.5em' }}>
          {provider.name}
        </div>
        <div className="level-item">
          <button onClick={clearProvider} className="button is-small is-danger is-outlined">
            Clear Provider
          </button>
        </div>
      </div>
    </div>
  );
};

const CreateProviderModal = ({ show, onHide, createProvider }) => {
  return (
    <Modal show={show} onHide={onHide}>
      <CreateProviderForm createProvider={createProvider} onSuccess={onHide} />
    </Modal>
  );
};

class _ExternalReferringProviderField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      createProviderModalOpen: false,
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.createNewProvider = this.createNewProvider.bind(this);
    this.clearCreatedProvider = this.clearCreatedProvider.bind(this);
  }

  openModal() {
    this.setState({ createProviderModalOpen: true });
  }

  closeModal() {
    this.setState({ createProviderModalOpen: false });
  }

  createNewProvider(providerFormValues) {
    const { dispatch, form } = this.props;
    const data = { provider: decamelizeKeys(providerFormValues) };
    return api.post('/agent_portal/api/providers', data).then(resp => {
      const createdProvider = resp.data;
      dispatch(change(form, 'createdReferringProvider', createdProvider));
    });
  }

  clearCreatedProvider() {
    const { dispatch, form } = this.props;
    dispatch(change(form, 'createdReferringProvider', null));
  }

  render() {
    const { createdProvider, onChange, name, label } = this.props;

    return (
      <div className="field">
        <div className="control-group new-booking-form-group">
          <label className="control-label">{label}</label>
          <div className="controls">
            {!!createdProvider ? (
              <CreatedProvider
                provider={createdProvider}
                clearProvider={this.clearCreatedProvider}
              />
            ) : (
              <div id="selectedReferringProvider-wrapper">
                <ProviderSelectionInput
                  name={name}
                  onChange={onChange}
                  loadOptions={fetchOptions}
                  className="input-xxlarge"
                />
                <div className="level-left" style={{ marginTop: '0.5rem' }}>
                  <p className="level-item is-size-7">
                    Couldn't find the provider you're looking for?
                  </p>
                  <div className="level-item">
                    <button
                      type="button"
                      onClick={this.openModal}
                      className="button is-small is-primary is-outlined"
                    >
                      Enter a new provider
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <CreateProviderModal
          show={this.state.createProviderModalOpen}
          onHide={this.closeModal}
          createProvider={this.createNewProvider}
        />
      </div>
    );
  }
}

function mapStateToProps(_state, ownProps) {
  const selector = formValueSelector(ownProps.form);
  return state => ({
    createdProvider: selector(state, 'createdReferringProvider'),
  });
}

const ExternalReferringProviderField = connect(mapStateToProps)(_ExternalReferringProviderField);

export { ExternalReferringProviderField };
